import { render, staticRenderFns } from "./ReviewAmu.vue?vue&type=template&id=114fe05c&"
import script from "./ReviewAmu.vue?vue&type=script&lang=js&"
export * from "./ReviewAmu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports